






import { antiFraudService } from '@core/services/antiFraud/AntiFraudService';
import RegisterContainer from '@accountCountries/registration/RegisterContainer.vue';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { wafService } from '@core/services/waf/WafService';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import {
    defineComponent,
    onMounted,
} from '@vue/composition-api';
import { getConfig } from '@superbet-group/web.lib.config';
import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';

export default defineComponent({
    name: 'RegisterPage',
    setup() {
        onMounted(() => {
            wafService.maybeLoadWafScript();
            if (shellLocalConfig.seonConfig.register.isServiceEnabled) {
                antiFraudService.initialize(getConfig().antiFraud);
            }
        });

        const { route } = useVueRouter();
        const { screenName, modalName } = route.value.params;
        if (shellLocalConfig.isScreenOpenAccountOpenSent) {
            AnalyticsSDK.getInstance().log('account_open', {
                screen_name: screenName,
                modal_name: modalName,
            });
        }
    },
    components: {
        RegisterContainer,
    },
});
